<canvas #canvasDocument class="canvas"></canvas>
<footer class="footer">
  <div class="footer__fps">{{ fps }}</div>
  <div class="footer__button-group">
    <p class="footer__label">Light type:</p>
    <button
      class="footer__button"
      *ngFor="let lightToolType of lightToolTypesMap.keys()"
      (tap)="selectLightTool(lightToolType)"
      [class.is-active]="selectedLightTools[lightToolType]"
    >
      {{ lightToolTypesMap.get(lightToolType) }}
    </button>
  </div>
</footer>
